import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import ProcessTaskGroupLineageViewer from 'processes/graph-builder-processes/flowchart-viz/ProcessTaskGroupLineageViewer';
import ProcessFlowchartTabState from 'processes/process-details/ProcessFlowchartTabState';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import WorkspaceStore from 'sidebar/WorkspaceStore';
import {GRAY_LIGHTER} from 'ui-library/Colors';

export default class ProcessFlowchartTabView extends BufferTabView<ProcessFlowchartTabState> {
  initialize(): void {
    this.listenTo(this.model, 'change:fileId', () => {
      this.render();
    });
  }
  render(): this {
    const props = {
      processId: this.model.get('fileId'),
      onSetProcess: (processId: string) => {
        const workspaceItems = WorkspaceStore.getState().workspaceItems;

        const workspaceContainsOpenId = workspaceItems.find((item) => item.fileId === processId);
        if (workspaceContainsOpenId) {
          // workspaceItems has an instance of the fileId open, so we will switch to that tab
          FileBrowserActions.openFile(processId);
        } else {
          const processFileState = this.model.get('processFileState');
          processFileState.setId(processId);
        }
      },
    };

    renderToDOM(
      <div className={classNames('react-tab-container', css(styles.tabBackground))}>
        <ProcessTaskGroupLineageViewer {...props} />
      </div>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<ProcessFlowchartTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ProcessFlowchartTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';

const styles = StyleSheet.create({
  tabBackground: {
    background: GRAY_LIGHTER,
    padding: 0,
    maxHeight: '100%',
    overflow: 'hidden',
  },
});
